const PdfIcon = (props) => {
    return (
        <svg
          width={25}
          height={25}
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M10.833 12.083h-2.5v5.834h.834v-2.5h1.666c.917 0 1.667-.75 1.667-1.667s-.75-1.667-1.667-1.667zm0 2.5H9.167v-1.666h1.666c.5 0 .834.333.834.833 0 .5-.334.833-.834.833zM15.833 12.083h-2.5v5.834h2.5c.917 0 1.667-.75 1.667-1.667v-2.5c0-.917-.75-1.667-1.667-1.667zm.834 4.167c0 .5-.334.833-.834.833h-1.666v-4.166h1.666c.5 0 .834.333.834.833v2.5z"
            fill="#6e0202"
          />
          <path
            d="M22.5 9.583h-6.667v-2.5l-5-5.833H1.667C.75 1.25 0 2 0 2.917v19.166C0 23 .75 23.75 1.667 23.75h12.5c.916 0 1.666-.75 1.666-1.667v-1.666H22.5c1.417 0 2.5-1.084 2.5-2.5v-5.834c0-1.416-1.083-2.5-2.5-2.5zM10.833 2.5l3.917 4.583h-3.083c-.417 0-.834-.416-.834-.833V2.5zM15 22.083a.835.835 0 01-.833.834h-12.5a.835.835 0 01-.834-.834V2.917c0-.417.334-.834.834-.834H10V6.25c0 .917.75 1.667 1.667 1.667H15v1.666H8.333c-1.416 0-2.5 1.084-2.5 2.5v5.834c0 1.416 1.084 2.5 2.5 2.5H15v1.666zm9.167-4.166c0 .916-.75 1.666-1.667 1.666H8.333c-.916 0-1.666-.75-1.666-1.666v-5.834c0-.916.75-1.666 1.666-1.666H22.5c.917 0 1.667.75 1.667 1.666v5.834z"
            fill="#6e0202"
          />
          <path
            d="M18.333 17.917h.834v-2.5h2.5v-.834h-2.5v-1.666H22.5v-.834h-4.167v5.834z"
            fill="#6e0202"
          />
        </svg>
      )
}

export default PdfIcon